export interface FingerprintState {
  fingerprint: string | null;
  error?: string;
}

export const fingerprintInitialState: FingerprintState = {
  fingerprint: null,
};
